// extracted by mini-css-extract-plugin
export default {"root":"style__root__vm0sl"};